module.exports = __webpack_public_path__ + "assets/img/t-b2.3cc270d8.gif";